export const AHP_COMPOSER_PLACEHOLDER = 'Send a message to the CLI session...'

export interface ComposerPlaceholderInput {
  startingSession: boolean
  isAhpSession: boolean
  steerable: boolean
}

export function resolveComposerPlaceholder({
  startingSession,
  isAhpSession,
  steerable,
}: ComposerPlaceholderInput): string {
  if (startingSession) return 'Waiting for agent to start session...'
  if (isAhpSession) return AHP_COMPOSER_PLACEHOLDER
  if (steerable) return 'Steer active session while agent is working'
  return 'What would you like to do next?'
}

export interface StopButtonVisibilityInput {
  hasActiveSession: boolean
  isAhpSession: boolean
  isAhpSessionWorking: boolean
  isSessionQueued?: boolean
}

/**
 * AHP environment sessions are long-lived CLI sessions that sit `idle` between
 * turns, so an active session alone doesn't mean there's anything to stop — only
 * a live turn is. Legacy cloud sessions run to completion, so any active session
 * remains stoppable.
 *
 * When early-stop is enabled, queued sessions are also stoppable even though
 * AHP hasn't connected yet.
 */
export function shouldShowStopButton({
  hasActiveSession,
  isAhpSession,
  isAhpSessionWorking,
  isSessionQueued,
}: StopButtonVisibilityInput): boolean {
  if (!hasActiveSession) return false
  if (isSessionQueued) return true
  if (isAhpSession) return isAhpSessionWorking
  return true
}
